import { useContext } from 'react'
import { DateContext } from '../context/DateContext'

const useDate = () => useContext(DateContext)

export default useDate